import { secretFieldToSubmit } from '../../utils/secretFields';

export function buildSlotPayload(form, { tokenEditing } = {}) {
  const payload = {
    label: form.label.trim(),
    provider: form.provider,
    botmaker_channel_id: form.botmaker_channel_id.trim() || null,
    phone_number_id: form.phone_number_id.trim() || null,
    waba_id: form.waba_id.trim() || null,
    api_host: form.api_host.trim() || null,
    phone_number: form.phone_number.trim() || null,
    sort_order: Number(form.sort_order) || 0,
    is_active: form.is_active,
    account_ids: form.account_ids || [],
  };

  const token = secretFieldToSubmit(form.token, { editing: tokenEditing });
  if (token) {
    payload.token = token;
  }

  return payload;
}

export default buildSlotPayload;
